<template>
  <div class="personalNav">
        <nav class="personal-cneter-nav">
            <div class="bankBox" v-for="(item, index) in nav" :key="index">
              <div class="bankTitle">{{item.title}}</div>
              <p class="itemName" @mouseenter="mouseenterItemName(index, i)" @mouseleave="mouseleaveItemName(index, i)" v-for="(obj, i) in item.children" :key="obj.name" @click="goto(obj.name)" :class="{'active': obj.name == active}">
                <img :src="obj.name == active || obj.showActive ? obj.iconActive : obj.icon" alt="">{{obj.title}}
              </p>
              <div class="linebox">
                  <div class="line"></div>
              </div>
            </div>
            <!-- <p>全部课程</p>
            <p>我的订单</p>
            <p>我的收藏</p>
            <p>我的关注</p>
            <p>个人信息</p>
            <p>创作中心</p> -->
            <div class="bankBox">
              <div class="bankTitle">其它</div>
              <p class="itemName" @click="gotoRouterJkt" @mouseenter="mouseenterOther(index)" @mouseleave="mouseleaveOther(index)" v-for="(item, index) in creation" :key="index">
                <img :src="item.showActive ? item.iconActive : item.icon" alt=""> {{item.title}}
              </p>
            </div>
        </nav>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'personalNav',
  data () {
    return {
      active: 'StartTopic',
      nav: [
        {title: '我的课程', children: [
            {title: '视频课程', showActive: false, name: 'ClassScheduleCard', icon: require('@/common/images/personal/icon_video2.svg'), iconActive: require('@/common/images/personal/icon_video.svg')}
        ]},
        {title: '我的题库', children: [
            // {title: '开始做题', showActive: false, name: 'StartTopic', icon: require('@/common/images/personal/icon_exercise2.svg'), iconActive: require('@/common/images/personal/icon_exercise.svg')},
            {title: '我的题库', showActive: false, name: 'MyQuBank', icon: require('@/common/images/personal/icon_qustion_bank2.svg'), iconActive: require('@/common/images/personal/icon_qustion_bank.svg')}
        ]},
        {title: '个人管理', children: [
            {title: '订单中心', showActive: false, name: 'MyOrder', icon: require('@/common/images/personal/icon_order2.svg'), iconActive: require('@/common/images/personal/icon_order.svg')},
            {title: '活动票券', showActive: false, name: 'HdTicket', icon: require('@/common/images/personal/icon_ticket2.svg'), iconActive: require('@/common/images/personal/icon_ticket.svg')},
            {title: '简历管理', showActive: false, name: 'Resume', icon: require('@/common/images/personal/icon_resume2.svg'), iconActive: require('@/common/images/personal/icon_resume.svg')},
            {title: '优惠券', showActive: false, name: 'MyCoupon', icon: require('@/common/images/personal/icon_coupon2.svg'), iconActive: require('@/common/images/personal/icon_coupon.svg')},
            {title: '兑换中心', showActive: false, name: 'ExchangeCenter', icon: require('@/common/images/personal/icon_redeem_code2.svg'), iconActive: require('@/common/images/personal/icon_redeem_code.svg')},
            {title: '我的成就', showActive: false, name: 'MyAchievement', icon: require('@/common/images/personal/icon_MyAchievement.svg'), iconActive: require('@/common/images/personal/icon_MyAchievement2.svg')},
            {title: '我的收藏', showActive: false, name: 'MyCollection', icon: require('@/common/images/personal/icon_collect2.svg'), iconActive: require('@/common/images/personal/icon_collect.svg')},
            {title: '我的关注', showActive: false, name: 'MyConcern', icon: require('@/common/images/personal/icon_attention2.svg'), iconActive: require('@/common/images/personal/icon_attention.svg')},
            {title: '个人信息', showActive: false, name: 'Info', icon: require('@/common/images/personal/icon_personal_msg2.svg'), iconActive: require('@/common/images/personal/icon_personal_msg.svg')},
            {title: '修改密码', showActive: false, name: 'UpdatePassword', icon: require('@/common/images/personal/icon_lock2.svg'), iconActive: require('@/common/images/personal/icon_lock.svg')}
        ]}
        // {title: '课程表', name: 'ClassScheduleCard'},
        // // {title: '全部课程', name: 'AllCourses'},
        // // {title: '全部题库', name: 'AllItemBank'},
        // // {title: '做题记录', name: 'DoRecord'},
        // {title: '订单中心', name: 'MyOrder'},
        // {title: '活动票券', name: 'HdTicket'},
        // {title: '简历管理', name: 'Resume'},
        // {title: '我的收藏', name: 'MyCollection'},
        // {title: '我的关注', name: 'MyConcern'},
        // {title: '修改密码', name: 'UpdatePassword'},
        // {title: '个人信息', name: 'Info'},
        // {title: '创作中心', name: 'CreativeCenter'}
      ],
      creation: [
          {title: '创作中心', showActive: false, name: 'ClassScheduleCard', icon: require('@/common/images/personal/icon_creation.svg'), iconActive: require('@/common/images/personal/icon_creation2.svg')}
      ]
    }
  },
  mounted () {
    this.updateRouter()
  },
  methods: {
    mouseenterItemName(index1, index2) {
      const obj = this.nav[index1]
      obj.children[index2].showActive = true
      this.$set(this.nav[index1], obj)
    },
    mouseleaveItemName(index1, index2) {
      const obj = this.nav[index1]
      obj.children[index2].showActive = false
      this.$set(this.nav[index1], obj)
    },
    mouseenterOther(index) {
      const obj = this.creation[index]
      obj.showActive = true
      this.$set(this.creation, obj)
    },
    mouseleaveOther(index) {
      const obj = this.creation[index]
      obj.showActive = false
      this.$set(this.creation, obj)
    },
    setActive(name) {
      this.active = name
    },
    goto(url) {
      this._isLogin(url)
      // if (url === 'Resume') {
      //   this.$emit('isShowContentNav', false, url)
      // } else {
      //   this.$emit('isShowContentNav', true, url)
      // }
      // this.$router.push({name: url})
    },
    // 路由调整 修改个人中心菜单栏样式
    updateRouter() {
      let pageName = this.$router.history.current.name
        this.setActive(pageName)
    },
    // 跳转新页面
    gotoRouterJkt() {
      if (!this.user.isLogin) {
          this.setLoginPop(true)
          return
      }
      window.open('https://czadmin.capwhale.com/creativeCenter?token='+this.user.loginToken, '_blank')
    },
    _isLogin(componentName) {
      if (this.user.isLogin || componentName === 'StartTopic') {
        if (componentName === 'Resume') {
          this.$emit('isShowContentNav', false, componentName)
        } else {
          this.$emit('isShowContentNav', true, componentName)
        }
        this.$router.push({name: componentName})
      } else {
        this.setLoginPop(true)
        // this.$toast.fail('请先登录')
      }
    },
    ...mapActions(['setLoginPop'])
    // ...mapGetters(['user'])
  },
  filters: {},
  watch: {
    // 监控路由变化
    $route: {
      handler() {
        this.updateRouter()
      }
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.personalNav {
    // position: fixed;
    width: 198px;
    .personal-cneter-nav {
      .linebox {
        padding: 0 14px;
        background: #fff;
        .line {
          height: 10px;
          border-bottom: 1px solid #E5E5E5;
        }
      }
      .bankTitle {
        padding: 0 30px;
        background: #fff;
        line-height: 38px;
        font-size: 12px;
        color: #999999;
      }
      .itemName {
          padding: 0 30px;
          color: #333;
          font-size: 14px;
          line-height: 45px;
          height: 45px;
          box-sizing: border-box;
          background: #fff;
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }
          &.active {
            border-left: solid 2px #409EFF;
            color: #409EFF;
            background: #F7FBFF;
          }

          &:hover {
            color: #409EFF;
          }
      }
  }
}
</style>